import React, { Component } from 'react';
import Top_Bar from '../../../Part_Sample/Top_Bar';
import ipcam_icon from '../../../../Images/Daikin_Images/image/Ipcam.png'
import delete_icon from '../../../../Images/Daikin_Images/image/Delete.png'
import { deleteCloudDevice } from './js/deletecamera';

export default class UniviewCameras extends Component {
	constructor(props) {
		super(props);

		let array = sessionStorage.getItem('devices').split(',');
		this.devices = [];
		for (let i in array) {
			if (array[i] == '') break;
			else {
				let temp_device = {};
				// Device id
				temp_device.device_id = array[i].substring(array[i].indexOf('Device ID:') + 10, array[i].indexOf('\n'));
				if (temp_device.device_id != '') array[i] = array[i].substring(array[i].indexOf('\n') + 1, array[i].length);
				// Device name
				temp_device.device_name = array[i].substring(array[i].indexOf('Device Name:') + 12, array[i].indexOf('\n'));
				if (temp_device.device_name != '') array[i] = array[i].substring(array[i].indexOf('\n') + 1, array[i].length);
				// Device Model
				temp_device.device_model = array[i].substring(array[i].indexOf('Dev Model:') + 10, array[i].indexOf('\n'));
				//if(temp_device.device_model!='')array[i] = array[i].substring(array[i].indexOf('\n'), array[i].length);
				this.devices.push(temp_device);
			}
		}

		this.is_admin = false;
		if (this.props.receiver.active_controller.user_class == 'Admin') this.is_admin = true;

		let controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
		this.controller_mac_addr = controller_info.mac_addr;
		this.controller_username = controller_info.username;
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('UniviewLogin');
	}

	//Add Camera
	handleAddCamera = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('UniviewAddCamera', { from: 'add' });
	}

	//Delete Camera
	handleDeleteCamera = (index) => {
		let selected_camera = this.devices[index];
		let uniview_info = JSON.parse(window.localStorage.getItem('uniview_info'));
		let username = uniview_info[this.controller_mac_addr][this.controller_username].username;
		let password = uniview_info[this.controller_mac_addr][this.controller_username].password;

		let confirmPopUp = window.confirm(this.props.receiver.getString("conf_del"));
		if (confirmPopUp == true) {
			window.app.showLoading();
			deleteCloudDevice(this.deleteSuccess, this.deleteFailed, username, password, selected_camera.device_id);
		}
	}

	deleteSuccess = () => {
		window.app.hideLoading();
		this.handlePrevious();
	}

	deleteFailed = () => {
		window.app.hideLoading();
		window.app.showToast(this.props.receiver.getString('uniview_failedtodeletecamera'), 3000);
	}

	//Accessing Camera Details
	accessCameraDetailsView = (index) => {
		window.app.content_area.current.switch_content.current.handleShowBottomControls();
		this.props.content_handler('UniviewCameraDetails', { index: index });
	}

	render() {

		// Tommy - 24/03/2021 - Add to determine device orientation
		let is_landscape = this.props.width > this.props.height;

		let main_content_style = {
			position: 'fixed',
			width: '100%',
			color: 'white',
			fontFamily: "system-ui, -apple-system, -apple-system-font, 'Segoe UI', 'Roboto', sans-serif",
			height: this.props.height,
		}

		let container_style = {
			paddingLeft: 20,
			paddingRight: 20,
			justifyContent: 'center',
			alignItems: 'center',
			height: this.props.height - 86,
			overflow: 'auto',
		}

		let deviceContainer = {
			backgroundColor: '#f9f9f9',
			borderRadius: 10,
			maxWidth: '100%',
			width: 'auto',
			alignItems: 'center',
			justifyContent: 'left',
			position: 'relative',
			display: 'flex',
			marginTop: 10,
			marginBottom: 10,
			padding: 10
		}

		let iconContainer = {
			paddingTop: 10,
			paddingLeft: 10,
			paddingBottom: 10,
			maxWidth: is_landscape ? '10%' : '20%',
			width: is_landscape ? '10%' : '20%',
		}

		let icon_style = {
			width: 52,
			height: 52,
		}

		let delete_icon_style = {
			width: 24,
			height: 24,
		}

		let deviceInfoContainer = {
			maxWidth: is_landscape ? '70%' : '60%',
			width: is_landscape ? '70%' : '60%',
			textAlign: 'left',
		}

		let deviceName = {
			fontSize: 16,
			color: 'black',
			fontWeight: 'bold',
			padding: 0,
			margin: 5,
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis'
		}

		let modelNumber = {
			// color: 'grey',
			fontSize: 14,
			color: '#BBBBBB',
			margin: 5,
			padding: 0,
			overflow: 'hidden',
			whiteSpace: 'nowrap',
			textOverflow: 'ellipsis'
		}

		let deleteIconContainer = {
			maxWidth: '20%',
			width: '20%',
			textAlign: 'center'
		}

		return (
			<div>
				<div style={main_content_style} className='slideInDown'>
					<Top_Bar
						width={this.props.width}
						title={this.props.receiver.getString('uniview')}
						left_button_type={'back'}
						handleLeftButton={this.handlePrevious}
						right_button_type={this.is_admin ? 'add' : null}
						handleRightButton={this.handleAddCamera}
					/>

					{/* List of devices */}
					<div style={container_style}>
						<div id="deviceContainer">
							{this.devices.map((device_info, index) => {
								return (
									<div style={deviceContainer} id={index}>
										<div style={iconContainer}>
											<img style={icon_style} src={ipcam_icon} />
										</div>
										<div style={deviceInfoContainer}>
											<p style={deviceName}>{device_info.device_name}</p>
											<p style={modelNumber}>{device_info.device_model}</p>
										</div>
										<div style={deleteIconContainer} onClick={() => { this.handleDeleteCamera(index) }}>
											<img style={delete_icon_style} src={delete_icon} />
										</div>
									</div>
								)
							})}
						</div>
					</div>
				</div>
			</div>
		)
	}
}